export const SET_CUS_DATA = 'SET_CUS_DATA';

export const SET_CUS_DATA_REQUEST ="SET_CUS_DATA_REQUEST";
export const SET_CUS_DATA_SUCCESS ="SET_CUS_DATA_SUCCESS";
export const SET_CUS_DATA_FAILURE ="SET_CUS_DATA_FAILURE";